const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

let zoomElements = [];

// ---- Utility: Throttle ----
function throttle(fn, limit = 100) {
  let inThrottle;
  return function (...args) {
    if (!inThrottle) {
      fn.apply(this, args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), limit);
    }
  };
}

// ---- Scroll in animation logic ----
function onIntersection(entries, observer) {
  entries.forEach((entry, index) => {
    const el = entry.target;
    if (entry.isIntersecting) {
      el.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      if (el.hasAttribute('data-cascade')) {
        el.style.setProperty('--animation-order', index);
      }
      observer.unobserve(el);
    } else {
      el.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      el.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationElements = Array.from(
    rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME)
  );
  if (!animationElements.length) return;

  if (isDesignModeEvent) {
    animationElements.forEach((el) => el.classList.add('scroll-trigger--design-mode'));
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationElements.forEach((el) => observer.observe(el));
}

// ---- Zoom-in animation logic ----
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  zoomElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));
  if (!zoomElements.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !zoomElements.includes(entry.target)) {
        zoomElements.push(entry.target);
      }
    });
  });

  zoomElements.forEach((el) => observer.observe(el));

  // Single global scroll listener
  window.addEventListener(
    'scroll',
    throttle(() => {
      zoomElements.forEach((el) => {
        el.style.setProperty('--zoom-in-ratio', 1 + 0.002 * percentageSeen(el));
      });
    }, 100),
    { passive: true }
  );
}

function percentageSeen(el) {
  const viewportHeight = window.innerHeight;
  const rect = el.getBoundingClientRect();
  const elementHeight = el.offsetHeight;

  if (rect.top > viewportHeight) return 0;
  if (rect.bottom < 0) return 100;

  const distance = viewportHeight - rect.top;
  return Math.round(distance / ((viewportHeight + elementHeight) / 100));
}

// ---- Init ----
window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) =>
    initializeScrollAnimationTrigger(event.target, true)
  );
  document.addEventListener('shopify:section:reorder', () =>
    initializeScrollAnimationTrigger(document, true)
  );
}
